import React from 'react'
import styled from '@emotion/styled'
import Link from 'redux-first-router-link'

import { doOpenNewTicketPage } from 'actions/pages'

import { Icon } from 'shared/ui'

const FAB = styled(Link)`
  &&& {
    display: block;
    position: absolute;
    bottom: ${props => props.theme.spacing['12']};
    left: ${props => props.theme.spacing['10']};
    padding: ${props => props.theme.spacing['7']};
    color: ${props => props.theme.color.buttonPrimary.text};
    background-color: ${props => props.theme.color.buttonPrimary.background};
    border-radius: 50%;
    box-shadow: -2px 3px 4px 0 rgba(0, 0, 0, 0.15);
    transition: background 150ms ease-in-out;
    z-index: 1;

    &:hover {
      color: ${props => props.theme.color.buttonPrimary.textHover};
      background-color: ${props =>
        props.theme.color.buttonPrimary.backgroundHover};
    }

    &:active {
      color: ${props => props.theme.color.buttonPrimary.textPressed};
      background-color: ${props =>
        props.theme.color.buttonPrimary.backgroundPressed};
    }
  }
`

const CreateIcon = styled(Icon)`
  height: ${props => props.theme.spacing['10']};
  width: ${props => props.theme.spacing['10']};
  color: inherit;
  font-size: ${props => props.theme.fontSize.x4large};
  transform: translate(-2px, -2px);

  &:hover {
    color: inherit;
  }
`

function NewTicketFAB() {
  return (
    <FAB id="new-conversation" to={doOpenNewTicketPage()}>
      <CreateIcon name="create" />
    </FAB>
  )
}

export default React.memo(NewTicketFAB)
